import React from "react";
import "./Privacy.css";

export default function Privacy() {
  return (
    <div className="privacy-page">
      <div className="container">
        <h1>Privacy Policy</h1>
        <p>
          This Privacy Policy explains how CooMBaaH collects, uses, discloses,
          and protects your personal information.
        </p>

        <h2>1. Data We Collect</h2>
        <ul>
          <li>
            <strong>Necessary data:</strong> Browser and device information
            required for the site to function (cookies, session data).
          </li>
          <li>
            <strong>Analytics:</strong> Non-identifying usage data (pageviews,
            navigation) to improve the site.
          </li>
          <li>
            <strong>Marketing:</strong> Optional tracking for personalized
            content and advertising when you consent.
          </li>
          <li>
            <strong>Booking information:</strong> When you make a booking
            through the site we collect your name and email so we can process
            and confirm the booking and communicate relevant details.
          </li>
        </ul>

        <h2>2. Cookies</h2>
        <p>
          We use cookies to store user preferences and to provide certain
          features. You can manage cookie consent via the "Cookie settings"
          control available on the site.
        </p>

        <h2>3. How We Use Your Data</h2>
        <p>
          Data is used to operate the website, improve user experience, and,
          when consent is given, to provide analytics and personalized content.
        </p>

        <h2>4. Third-party Services</h2>
        <p>
          We may use third-party services (for example Google Analytics) which
          have their own privacy policies. These services may set cookies and
          collect limited information about your visit.
        </p>

        <h2>5. Data Retention</h2>
        <p>
          We retain personal data only as long as necessary for the purposes
          described. Consent choices are stored locally in your browser
          (localStorage) under the key <code>cookie_consent_v1</code>.
        </p>

        <h2>6. Your Rights</h2>
        <p>
          You can withdraw consent at any time using the Cookie settings (footer
          or banner). You may also contact us to request access, correction, or
          deletion of your personal data where applicable.
        </p>

        <h2>7. Contact</h2>
        <p>
          For privacy questions, contact:{" "}
          <a href="mailto:privacy@coombaah.com">privacy@coombaah.com</a>
        </p>

        <p className="small">Last updated: 31 December 2025</p>
      </div>
    </div>
  );
}
